
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import { siteUrl } from 'constants/app';
import dynamic from 'next/dynamic';

const Earnings = dynamic(() => import('features/pro-tools/Earnings'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function EarningsPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Earning Tools"
        description="Lihat rekap laba bersih emiten setiap periodenya secara up to date. Bandingkan dengan Estimasi Analis dan dengan performa tahun sebelumnya."
        url={`${siteUrl}/info/pro-tools/earnings`}
      />
      <Earnings />
    </HomePageLayout>
  );
}

export default EarningsPage;
